import React, { useState, useEffect, useContext } from "react";
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { UserContext } from "context/User/UserContext";
import { useAppConfig } from "context/ConfigContext";

const HeaderBrand = () => (
  <Navbar className="navbar-sph position-relative" expand="lg">
    <Navbar.Collapse>
      <Navbar.Brand
        as={Link}
        to={process.env.PUBLIC_URL}
        className="mx-auto navbar-sph"
        style={{ height: "60px" }}
      >
        <div className="h-100 d-flex align-items-center">
          <img
            src={
              process.env.PUBLIC_URL +
              `/img/branding/android-chrome-512x512.png`
            }
            width="60"
            className="d-inline-block align-top"
            alt="HERO logo"
          />
          <div className="d-inline-block align-top mx-2">HERO Study</div>
        </div>
      </Navbar.Brand>
    </Navbar.Collapse>
  </Navbar>
);

const HeaderBrandCompact = () => (
  <Navbar className="navbar-sph position-relative" expand="lg">
    <Container>
      <Navbar.Brand
        as={Link}
        to={process.env.PUBLIC_URL}
        className="mx-auto navbar-sph"
        style={{ height: "60px" }}
      >
        <div className="h-100 d-flex align-items-center">
          <img
            src={
              process.env.PUBLIC_URL +
              `/img/branding/android-chrome-512x512.png`
            }
            width="60"
            className="d-inline-block align-top"
            alt="HERO logo"
          />
          <div className="d-inline-block align-top mx-2">HERO Study</div>
        </div>
      </Navbar.Brand>
    </Container>
  </Navbar>
);

const SubjectOptionsEDU = () => {
  const location = useLocation();

  return (
    <>
      <Nav.Link
        as={Link}
        to={process.env.PUBLIC_URL + "about"}
        className="nav-link-sph"
      >
        About
      </Nav.Link>
      <Nav.Link
        as={Link}
        to={process.env.PUBLIC_URL + "/subject/edu/modules/1/learning"}
        className={`nav-link-sph ${
          location.pathname.startsWith(
            process.env.PUBLIC_URL + "/subject/edu/modules/1",
          ) && "active"
        }`}
      >
        Week-1
      </Nav.Link>
      <Nav.Link
        as={Link}
        to={process.env.PUBLIC_URL + "/subject/edu/modules/2/learning"}
        className={`nav-link-sph ${
          location.pathname.startsWith(
            process.env.PUBLIC_URL + "/subject/edu/modules/2",
          ) && "active"
        }`}
      >
        Week-2
      </Nav.Link>
      <Nav.Link
        as={Link}
        to={process.env.PUBLIC_URL + "/subject/edu/modules/3/learning"}
        className={`nav-link-sph ${
          location.pathname.startsWith(
            process.env.PUBLIC_URL + "/subject/edu/modules/3",
          ) && "active"
        }`}
      >
        Week-3
      </Nav.Link>
      <Nav.Link
        as={Link}
        to={process.env.PUBLIC_URL + "/subject/edu/modules/4/learning"}
        className={`nav-link-sph ${
          location.pathname.startsWith(
            process.env.PUBLIC_URL + "/subject/edu/modules/4",
          ) && "active"
        }`}
      >
        Week-4
      </Nav.Link>
      <Nav.Link
        as={Link}
        to={process.env.PUBLIC_URL + "/subject/edu/modules/5/learning"}
        className={`nav-link-sph ${
          location.pathname.startsWith(
            process.env.PUBLIC_URL + "/subject/edu/modules/5",
          ) && "active"
        }`}
      >
        Week-5
      </Nav.Link>
      <Nav.Link
        as={Link}
        to={process.env.PUBLIC_URL + "/subject/edu/modules/6/learning"}
        className={`nav-link-sph ${
          location.pathname.startsWith(
            process.env.PUBLIC_URL + "/subject/edu/modules/6",
          ) && "active"
        }`}
      >
        Week-6
      </Nav.Link>
      <Nav.Link
        as={Link}
        to={process.env.PUBLIC_URL + `/subject/quiz/report`}
        className={`nav-link-sph ${
          location.pathname.startsWith(
            process.env.PUBLIC_URL + "/subject/quiz/report",
          ) && "active"
        }`}
      >
        Quiz Reports
      </Nav.Link>
    </>
  );
};

const ResearcherOptions = () => {
  const location = useLocation();

  return (
    <>
      <Nav.Link
        as={Link}
        to={process.env.PUBLIC_URL + "/researcher/reports"}
        className={`nav-link-sph ${
          location.pathname.startsWith(
            process.env.PUBLIC_URL + "/researcher/reports",
          ) && "active"
        }`}
      >
        Reports
      </Nav.Link>
      <Nav.Link
        as={Link}
        to={process.env.PUBLIC_URL + "/researcher/user-management"}
        className={`nav-link-sph ${
          location.pathname.startsWith(
            process.env.PUBLIC_URL + "/researcher/user-management",
          ) && "active"
        }`}
      >
        User Management
      </Nav.Link>
      <Dropdown as={Nav.Item}>
        <Dropdown.Toggle
          as={Nav.Link}
          id="study-assessment-dropdown"
          className={`nav-link-sph ${
            (location.pathname.startsWith(
              process.env.PUBLIC_URL + "/researcher/tasks/stroop",
            ) ||
              location.pathname.startsWith(
                process.env.PUBLIC_URL + "/researcher/tasks/arithmetic",
              )) &&
            "active"
          }`}
        >
          Study Assesment
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            as={Link}
            to={process.env.PUBLIC_URL + "/researcher/tasks/stroop"}
            // target="_blank"
            // rel="noopener noreferrer"
            className="nav-link-sph"
          >
            Stroop
          </Dropdown.Item>
          <Dropdown.Item
            as={Link}
            to={process.env.PUBLIC_URL + "/researcher/tasks/arithmetic"}
            // target="_blank"
            // rel="noopener noreferrer"
            className="nav-link-sph"
          >
            Arithmetic
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

function Header() {
  const { user, login, logout, subjectStage } = useContext(UserContext);
  const appConfig = useAppConfig();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  let HeaderOptions;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (user.role === "researcher" && location.pathname !== "/") {
    HeaderOptions = null;
  }

  if (user.role === "subject" && user.randomization === "EDU") {
    HeaderOptions = SubjectOptionsEDU;
  }

  if (user.role === "subject" && user.randomization === "HRVB") {
    HeaderOptions = null;
  }

  return (
    <>
      {!isMobile && (
        <div>
          <HeaderBrand />
        </div>
      )}
      <Navbar className="navbar-sph position-relative" expand="lg">
        {isMobile && <HeaderBrandCompact />}
        <Navbar.Toggle className="border-0 bg-secondary" />
        <Navbar.Collapse>
          <Nav className="d-flex justify-content-evenly align-items-center w-100 navbar-sph">
            {HeaderOptions && <HeaderOptions />}
            {user && user.role === "researcher" && <ResearcherOptions />}
            {!user.isLoggedIn ? (
              <Nav.Link
                as={Link}
                to={appConfig.COGNITO_HOSTED_UI_LOGIN}
                className="nav-link-sph"
              >
                Login
              </Nav.Link>
            ) : (
              <Nav.Link onClick={logout} className="nav-link-sph">
                Logout user {`${user.username}`}
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
}

export default Header;
